import React from 'react';
import { styled } from 'styled-components';
import * as Icon from './Icons/index.js';
import { Checkbox } from './index.js';
const OverrideSetting = (props) => {
    return (React.createElement(Wrapper, { className: `${props.className} iris-input-container override-setting-wrapper` },
        React.createElement(OverrideSpan, null,
            React.createElement(Checkbox, { checkMark: true, style: props.style, placeholder: props.placeholder, checked: props.checked, onChange: props.onChange }),
            props.infoIcon && (React.createElement(Icon.Info, { "data-tooltip-content": props.iconTip, "data-tooltip-id": 'tooltip-default', onClick: props.iconOnClick }))),
        React.createElement("div", { style: { opacity: props.checked ? '100%' : '50%' } }, props.children)));
};
const Wrapper = styled.span `
  margin-bottom: 20px;
`;
const OverrideSpan = styled.span `
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`;
export default OverrideSetting;
//# sourceMappingURL=OverrideSetting.js.map